<template>
  <div class="max-w-3xl px-6 mx-auto">
    <slot />
  </div>
</template>
